module.exports = __webpack_public_path__ + "img/ferdi-kaza-sigortasi.66698f41.svg";